import { ONE_DAY_IN_SECONDS } from '@/constants';
import {
  GET_FREEZE_STORAGE_LOCATIONS,
  GET_STORAGE_LOCATIONS,
  StorageLocation,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

export const locationsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getStorageLocations: build.query({
      keepUnusedDataFor: ONE_DAY_IN_SECONDS,
      query: (variables) => ({
        document: GET_STORAGE_LOCATIONS,
        variables,
      }),
      transformResponse: (response: {
        storageLocations: { items: StorageLocation[] };
      }) => response.storageLocations.items,
    }),
    getFreezeStorageLocations: build.query({
      keepUnusedDataFor: ONE_DAY_IN_SECONDS,
      query: (fertilizationSiteId) => ({
        document: GET_FREEZE_STORAGE_LOCATIONS,
        variables: { fertilizationSiteId },
      }),
      transformResponse: (response: {
        storageLocations: { items: StorageLocation[] };
      }) => response.storageLocations.items,
    }),
  }),
});

export const {
  useGetFreezeStorageLocationsQuery,
  useGetStorageLocationsQuery,
  useLazyGetFreezeStorageLocationsQuery,
  useLazyGetStorageLocationsQuery,
} = locationsApi;
